module.exports = __webpack_public_path__ + "img/praise.12508bcc.png";